module.exports = __webpack_public_path__ + "static/media/rattlescan.846e1eac.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/PortfolioPage/images/rattlescan.gif
// module id = 355
// module chunks = 0